import { Component, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';

import { Environment } from 'src/environments/environment.model';
import { PowerbiReportComponent } from '@next/core-lib/powerbi-embedded';

@Component({
    selector: 'app-virus-dashboard',
    template: `
    <agr-powerbi-report [workspaceId]="workspaceId" [reportId]="reportId"/>`,
    imports: [PowerbiReportComponent],
})
export class VirusDashboardComponent {
  private readonly env = inject<Environment>(EnvironmentInjector);

  public readonly workspaceId: string;
  public readonly reportId: string;

  constructor() {
    this.workspaceId = this.env.VIRUS_DASHBOARD_WORKSPACE_ID;
    this.reportId = this.env.VIRUS_DASHBOARD_REPORT_ID;
  }
}
